const SUPPRESSION_WINDOW_MS = 30_000;

let suppressedUntil = 0;

export const suppressWagerFreeNotification = () => {
  suppressedUntil = Date.now() + SUPPRESSION_WINDOW_MS;
};

export const clearWagerFreeSuppression = () => {
  suppressedUntil = 0;
};

export const consumeWagerFreeSuppression = (): boolean => {
  const isSuppressed = Date.now() < suppressedUntil;
  suppressedUntil = 0;

  return isSuppressed;
};
